import { useTranslation } from "react-i18next";

export default function WanneerReparatie() {
  const { t } = useTranslation("kozijn-reparatie");
  const items = t("wanneerReparatie.items", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-6 md:mb-8">
          {t("wanneerReparatie.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed text-center mb-10 md:mb-14 max-w-[700px] mx-auto">
          {t("wanneerReparatie.intro")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-xl p-5 md:p-6 hover:border-brand-yellow transition-colors"
            >
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-brand-yellow flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-error-warning-line text-brand-text text-sm w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="font-geist font-bold text-base md:text-lg text-brand-text mb-1.5">
                    {item.title}
                  </h3>
                  <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}